import React from 'react';

// Slim launch-announcement bar for FHO Platform partner pages.
// Placed directly below the hero on PlatformPage and every segment page.
// One file controls the message everywhere — update or remove here after Sept 1.

// RETIRED 2026-09-18. The launch copy announced end-user access opening
// September 1 2026 — that date has passed and the banner was advertising a
// launch that already happened, on 15 public pages.
//
// Returning null rather than deleting the component: 15 pages import and
// render it, so this removes the banner everywhere from one file and leaves
// the markup below intact if a different announcement is wanted later.
const LaunchBanner = () => null;

// eslint-disable-next-line no-unused-vars
const LaunchBannerRetired = () => {
  const [isMobile, setIsMobile] = React.useState(
    typeof window !== 'undefined' && window.innerWidth < 768
  );

  React.useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <div style={{
      background: 'linear-gradient(135deg, #1e3a5f 0%, #4f46e5 100%)',
      color: '#fff',
      padding: isMobile ? '16px 20px' : '14px 5%',
      fontFamily: "'Libre Franklin', system-ui, sans-serif",
    }}>
      <div style={{
        maxWidth: '1200px', margin: '0 auto',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        gap: isMobile ? '12px' : '24px',
        flexDirection: isMobile ? 'column' : 'row',
        textAlign: isMobile ? 'center' : 'left',
      }}>
        {/* Live indicator — encodes that onboarding is open now */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
          <span style={{
            width: '9px', height: '9px', borderRadius: '50%',
            background: '#34d399', boxShadow: '0 0 0 4px rgba(52,211,153,0.25)',
            display: 'inline-block', flexShrink: 0,
          }} />
          <span style={{
            fontSize: '11px', fontWeight: 700, letterSpacing: '0.12em',
            textTransform: 'uppercase', color: '#a7f3d0', whiteSpace: 'nowrap',
          }}>Now Onboarding</span>
        </div>

        {/* Message */}
        <p style={{
          margin: 0, fontSize: isMobile ? '13.5px' : '14.5px',
          lineHeight: 1.5, color: 'rgba(255,255,255,0.92)',
        }}>
          <strong style={{ color: '#fff' }}>Free platform access for partners today.</strong>{' '}
          End-user access opens <strong style={{ color: '#fff' }}>September&nbsp;1,&nbsp;2026</strong>. Partner now to give your members, clients, and groups first access at launch.
        </p>

        {/* CTA — scrolls to the on-page quote form (tags the lead by segment);
            falls back to the segment picker on pages without a form (e.g. PlatformPage) */}
        <button
          onClick={() => {
            const form = document.getElementById('quote-tool');
            const target = form || document.getElementById('partnerships');
            if (target) {
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else {
              window.location.href = '/platform#partnerships';
            }
          }}
          style={{
            flexShrink: 0,
            background: '#fff', color: '#1e3a5f',
            fontSize: '13.5px', fontWeight: 700,
            padding: '10px 20px', borderRadius: '8px',
            border: 'none', cursor: 'pointer',
            whiteSpace: 'nowrap',
            fontFamily: "'Libre Franklin', system-ui, sans-serif",
            transition: 'transform 0.15s ease, box-shadow 0.15s ease',
          }}
          onMouseOver={(e) => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 6px 18px rgba(0,0,0,0.2)'; }}
          onMouseOut={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}
        >
          Become a Partner →
        </button>
      </div>
    </div>
  );
};

export default LaunchBanner;
